import "./RunningDevice.css"; // 导入CSS文件
import rotate from '../../assets/rotate.webp'

function RunningDevice(props) {
  const { hidden, device, style } = props; // 从props中获取style属性

  if (hidden !== undefined && !!hidden) {
    return null;
  }
  if (!device) {
    console.log("no device specified");
    return null;
  }

  return (
    <div
      style={style}
      className="inline-flex  items-center "
    >
      <img className="animate-spin-slow rotateIcon" src={rotate} alt="" />
      RUNNING <span className="mx-1">ON</span><span  style={{ fontWeight: 200 }}>{device}</span>
    </div>
  );
}

export default RunningDevice;
